module.exports = __webpack_public_path__ + "img/physical_icon.a58b17bf.svg";